import NextLink from "next/link"
import cn from "classnames"
import isInternalLink from "utilities/isInternalLink"

export default function CallToAction({
  href,
  target = null,
  children,
  style = "primary",
  button = false,
  className,
  ...delegated
}) {
  const ctaStyles = {
    primary:
      "primary-link inline-block px-9 py-3 text-m3 sm:text-2xl font-bold font-secondary uppercase text-center rounded-full no-underline text-stone-light bg-aqua-mid hover:bg-moss-light hover:text-evergreen border-[3px] border-aqua-mid hover:border-moss-light",
    secondary:
      "secondary-link inline-block px-6 py-2 text-m3 sm:text-2xl font-bold font-secondary uppercase text-stone-light text-center border-evergreen bg-evergreen border-[3px] rounded-full no-underline hover:bg-stone-light hover:text-evergreen hover:border-stone-light whitespace-nowrap",
    tertiary:
      "tertiary-link inline-block px-9 py-3 text-m3 sm:text-2xl font-bold font-secondary uppercase text-aqua text-center border-aqua border-[3px] rounded-full no-underline hover:bg-aqua hover:text-white whitespace-nowrap",
    small:
      "small-link inline-block px-6 text-m1 font-bold uppercase text-center rounded-full no-underline text-stone-light bg-aqua-mid border-[3px] border-aqua-mid hover:bg-moss-light hover:text-evergreen hover:border-moss-light",
    inline: "inline-link inline text-base underline text-inherit font-medium hover:no-underline",
  }
  const styles = cn(
    "inline-block cursor-pointer max-w-full transition-all duration-300 not-prose", // default styles
    ctaStyles[style],
    className,
  )

  if (button) {
    return (
      <button className={styles} {...delegated}>
        {children}
      </button>
    )
  }

  if (!href)
    return (
      <span data-type="invalid-link" className={styles}>
        {children}
      </span>
    )

  const internal = isInternalLink(href)

  target = target ?? internal ? "_self" : "_blank"

  if (href.startsWith("tel:") || href.startsWith("mailto:")) {
    target = "_self"
  }

  return internal ? (
    <NextLink href={href} data-type="route" className={styles} {...delegated}>
      {children}
    </NextLink>
  ) : (
    <a data-type="external" className={styles} target={target} href={href} {...delegated}>
      {children}
    </a>
  )
}
